module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/star-76d832eacc6bbfb16a9d4b3f22b14ea1.svg";